import React from 'react';
import { FaEnvelopeOpen } from 'react-icons/fa';
import { INotificationsProps } from '../../DropdownNotification';
import { NotificationItem } from '../NotificationsItem';

interface INotificationListProps {
  notifications: Array<INotificationsProps>;
  onRead: (id: any) => void;
  currentTime: Date;
}

function NotificationsList({
  notifications,
  onRead,
  currentTime,
}: INotificationListProps) {
  return (
    <ul className="flex flex-col max-h-[270px] overflow-y-scroll flex-1 w-full [&::-webkit-scrollbar]:w-3 [&::-webkit-scrollbar-track]:bg-white [&::-webkit-scrollbar-thumb]:bg-[var(--black)] [&::-webkit-scrollbar-thumb]:rounded-[20px] [&::-webkit-scrollbar-thumb]:border-[3px] [&::-webkit-scrollbar-thumb]:border-white">
      {notifications.length ? (
        notifications.map((notification: INotificationsProps) => {
          return (
            <NotificationItem
              // eslint-disable-next-line no-underscore-dangle
              key={notification._id}
              openAndCloseNotification={onRead}
              currentTime={currentTime}
              notification={notification}
            />
          );
        })
      ) : (
        <div className="text-xl self-center py-[15px] md:py-[15px] md:px-0 px-[15px]">
          <FaEnvelopeOpen className="inline mr-[7px] mt-[5px]" />
          Não há nada por aqui
        </div>
      )}
    </ul>
  );
}

export default NotificationsList;
